import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        question:'', // 智能问答问题
        uid:'', // 智能问答问题uid
        questionList:[], // 智能问答推荐的问题列表
        keyword:'' // 文献检索关键词
    },
    mutations: {
        setState(state, param) {
            state[param.key] = param.value;
        },
    },
    actions: {
       
    }
});
